var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#5F5FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.654 2.66602H10.3473C6.66732 2.66602 5.33398 3.99935 5.33398 7.74602V24.2527C5.33398 27.9993 6.66732 29.3327 10.3473 29.3327H21.6407C25.334 29.3327 26.6673 27.9993 26.6673 24.2527V7.74602C26.6673 3.99935 25.334 2.66602 21.654 2.66602ZM16.0007 25.7327C14.7207 25.7327 13.6673 24.6793 13.6673 23.3993C13.6673 22.1193 14.7207 21.066 16.0007 21.066C17.2807 21.066 18.334 22.1193 18.334 23.3993C18.334 24.6793 17.2807 25.7327 16.0007 25.7327ZM18.6673 8.33268H13.334C12.7873 8.33268 12.334 7.87935 12.334 7.33268C12.334 6.78602 12.7873 6.33268 13.334 6.33268H18.6673C19.214 6.33268 19.6673 6.78602 19.6673 7.33268C19.6673 7.87935 19.214 8.33268 18.6673 8.33268Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.2e4a17c4b3ce56612fa805e8adbcf685.svg";
export { ForwardRef as ReactComponent };